// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { parseDate, parseDateTime, serializeDate, serializeDateTime } from "../runtime";
import type { OGC3DTilesetsMeta } from "./OGC3DTilesetsMeta";
import {
  instanceOfOGC3DTilesetsMeta,
  OGC3DTilesetsMetaFromJSON,
  OGC3DTilesetsMetaFromJSONTyped,
  OGC3DTilesetsMetaToJSON,
} from "./OGC3DTilesetsMeta";
import type { RasterMeta } from "./RasterMeta";
import {
  instanceOfRasterMeta,
  RasterMetaFromJSON,
  RasterMetaFromJSONTyped,
  RasterMetaToJSON,
} from "./RasterMeta";
import type { RasterSeriesMeta } from "./RasterSeriesMeta";
import {
  instanceOfRasterSeriesMeta,
  RasterSeriesMetaFromJSON,
  RasterSeriesMetaFromJSONTyped,
  RasterSeriesMetaToJSON,
} from "./RasterSeriesMeta";
import type { ScenarioMeta } from "./ScenarioMeta";
import {
  instanceOfScenarioMeta,
  ScenarioMetaFromJSON,
  ScenarioMetaFromJSONTyped,
  ScenarioMetaToJSON,
} from "./ScenarioMeta";
import type { SchematisationMeta } from "./SchematisationMeta";
import {
  instanceOfSchematisationMeta,
  SchematisationMetaFromJSON,
  SchematisationMetaFromJSONTyped,
  SchematisationMetaToJSON,
} from "./SchematisationMeta";
import type { VectorMeta } from "./VectorMeta";
import {
  instanceOfVectorMeta,
  VectorMetaFromJSON,
  VectorMetaFromJSONTyped,
  VectorMetaToJSON,
} from "./VectorMeta";

/**
 * @type FileDescriptorReadMeta
 *
 * @export
 */
export type FileDescriptorReadMeta =
  | OGC3DTilesetsMeta
  | RasterMeta
  | RasterSeriesMeta
  | ScenarioMeta
  | SchematisationMeta
  | VectorMeta;

export function FileDescriptorReadMetaFromJSON(json: any): FileDescriptorReadMeta {
  return FileDescriptorReadMetaFromJSONTyped(json, false);
}

export function FileDescriptorReadMetaFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FileDescriptorReadMeta {
  if (json == null) {
    return json;
  }
  if (typeof json !== "object") {
    return json;
  }
  if (instanceOfOGC3DTilesetsMeta(json)) {
    return OGC3DTilesetsMetaFromJSONTyped(json, true);
  }
  if (instanceOfRasterMeta(json)) {
    return RasterMetaFromJSONTyped(json, true);
  }
  if (instanceOfRasterSeriesMeta(json)) {
    return RasterSeriesMetaFromJSONTyped(json, true);
  }
  if (instanceOfScenarioMeta(json)) {
    return ScenarioMetaFromJSONTyped(json, true);
  }
  if (instanceOfSchematisationMeta(json)) {
    return SchematisationMetaFromJSONTyped(json, true);
  }
  if (instanceOfVectorMeta(json)) {
    return VectorMetaFromJSONTyped(json, true);
  }
  return {} as any;
}

export function FileDescriptorReadMetaToJSON(json: any): any {
  return FileDescriptorReadMetaToJSONTyped(json, false);
}

export function FileDescriptorReadMetaToJSONTyped(
  value?: FileDescriptorReadMeta | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }
  if (typeof value !== "object") {
    return value;
  }
  if (instanceOfOGC3DTilesetsMeta(value)) {
    return OGC3DTilesetsMetaToJSON(value as OGC3DTilesetsMeta);
  }
  if (instanceOfRasterMeta(value)) {
    return RasterMetaToJSON(value as RasterMeta);
  }
  if (instanceOfRasterSeriesMeta(value)) {
    return RasterSeriesMetaToJSON(value as RasterSeriesMeta);
  }
  if (instanceOfScenarioMeta(value)) {
    return ScenarioMetaToJSON(value as ScenarioMeta);
  }
  if (instanceOfSchematisationMeta(value)) {
    return SchematisationMetaToJSON(value as SchematisationMeta);
  }
  if (instanceOfVectorMeta(value)) {
    return VectorMetaToJSON(value as VectorMeta);
  }
  return {};
}
